import { useDroppable } from "@dnd-kit/core"
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"
import SortableItem from "../SortableItem/SortableItem"

const DroppableContainer = ({ id, items, onUngroup }) => {
   const { setNodeRef, isOver } = useDroppable({ id })

   return (
      <div
         ref={setNodeRef}
         className={`p-4 m-3 rounded-xl min-h-[120px] transition-all duration-200 shadow-inner
            ${
               isOver
                  ? "bg-indigo-50 border-2 border-dashed border-indigo-600"
                  : "bg-gray-100 border-2 border-dashed border-gray-200"
            }`}
      >
         <div className="mb-3 font-medium text-sm text-gray-500">
            AD GROUP
         </div>
         <SortableContext
            items={items.map(item => item.id)}
            id={id}
            strategy={verticalListSortingStrategy}
         >
            {items.map((item, index) => (
               <SortableItem
                  key={item.id}
                  id={item}
                  // Show Ungroup on every item except the first when there are multiple items in the group
                  onUngroup={items.length > 1 && index !== 0 ? onUngroup : undefined}
               />
            ))}
         </SortableContext>
      </div>
   )
}

export default DroppableContainer
